import { styled, useTheme } from '@mui/material';
import { Typography } from '../Typography/Typography';

type Props = {
  isActive: boolean;
  activeLabel?: string;
  inactiveLabel?: string;
  style?: React.CSSProperties;
};

export const StatusBadge = ({
  isActive,
  activeLabel = 'Active',
  inactiveLabel = 'Inactive',
  style,
}: Props) => {
  const { colors } = useTheme();

  return (
    <Container style={style}>
      <Dot isActive={isActive} />
      <Typography variant='body' color={colors.text.main}>
        {isActive ? activeLabel : inactiveLabel}
      </Typography>
    </Container>
  );
};

const Container = styled('div')`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.surfaceStatus.noAction};
`;

const Dot = styled('span')<{ isActive: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ isActive }) => (isActive ? '#439C3D' : '#6B6B80')};
  flex-shrink: 0;
`;
